import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {DomSanitizer} from '@angular/platform-browser';
import {EventsService} from '../events.service';

@Component({
  selector: 'app-add-event-pop-up',
  templateUrl: './add-event-pop-up.component.html',
  styleUrls: ['./add-event-pop-up.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AddEventPopUpComponent implements OnInit {
  dimentions = {
    'horizontal': {width: 640, height: 369},
    'square': {width: 440, height: 431},
    'vertical': {width: 271, height: 431}
  };

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private sanitizer: DomSanitizer,
              private eventService: EventsService,
              public dialogRef: MatDialogRef<AddEventPopUpComponent>) {
  }

  ngOnInit() {
  }

  getVimeo() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${this.data.video.split('https://vimeo.com/')[1]}?loop=1&autoplay=1&title=0&byline=0&portrait=0`);
  }

  createProjectFromTemplate(id) {
    if (this.eventService.isAuthenticated) {
      this.eventService.createProject(id).subscribe(res => {
        // @ts-ignore
        window.location.href = `/videomaker/${res.data.project_id}`;
      });
    } else {
      window.location.href = '/users/sign_in';
    }
  }

  sendTextToQueue() {
    this.eventService.sendToQueue(this.processInfo()).subscribe(res => {
      // @ts-ignore
      window.location.href = `/outline/${res.key}`;
    });
  }

  processInfo() {
    const removedHashTagText = this.unscapeHtml(this.data.info).replace(/<(?:.|\n)*?>/gm, '').split('#');
    return removedHashTagText.length === 1 ? removedHashTagText.join(' ').split(/(?=[A-Z])/).join(' ') : removedHashTagText.slice(1).join(' ').split(/(?=[A-Z])/).join(' ');
  }

  unscapeHtml(html) {
    return unescape(html.replace(/%E2%80%99/g, '\''));
  }

  getWidth() {
    // return this.dimentions['horizontal'].width;
    return this.dimentions[this.data.orientation].width;
  }

  getHeight() {
    return this.dimentions[this.data.orientation].height;
    // return this.dimentions['horizontal'].height;
  }

  close() {
    this.dialogRef.close(false);
  }


}
